// extracted by mini-css-extract-plugin
module.exports = {"clubNav":"_5eda2a1"};